import { render, staticRenderFns } from "./PostsInfinite.vue?vue&type=template&id=a838b506"
import script from "./PostsInfinite.vue?vue&type=script&lang=js"
export * from "./PostsInfinite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports